export default __webpack_public_path__ + "static/lena@2x-d5b54922b63d30d6be12aed50775eba7.png";